export default function Sidebar({ active, setActive }) {
  const links = [
    ["dashboard", "📊 Dashboard"],
    ["analytics", "📈 Analytics"],
    ["users", "👤 Users"],
    ["devices", "💻 Devices"],
    ["employees", "🧑‍🔧 Employees"],
    ["settings", "⚙️ Settings"],
  ];

  return (
    <div className="sidebar">
      <h2>Enyard</h2>
      {links.map(([key, label]) => (
        <button
          key={key}
          className={active === key ? "active" : ""}
          onClick={() => setActive(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
